export default "__VITE_ASSET__fe1987f3__"